import { ReactComponent as HelpIcon } from 'assets/icons/menu/ajuda.svg';
import { ReactComponent as SettingsIcon } from 'assets/icons/menu/configuracoes.svg';
import { ReactComponent as DocsIcon } from 'assets/icons/menu/documentacao.svg';
import { ReactComponent as VentureIcon } from 'assets/icons/menu/ficha-tecnica.svg';
import { ReactComponent as ReportsIcon } from 'assets/icons/menu/relatorios.svg';
import { IAppRoute } from 'interfaces/route';
import { userRoles } from 'interfaces/user';
import { PureComponent } from 'react';

import DocumentationRouter from './documentationRouter';
import HelpRouter from './helpRouter';
import Home from './Home';
import ReportsRouter from './reportsRouter';
import SettingsRouter from './settingsRouter';
import VentureView from './Venture/View';

export default class Router extends PureComponent {
  public static routes: IAppRoute[] = [
    {
      path: '/venture/account',
      sideDrawer: { display: 'Ficha Técnica', order: 0, icon: VentureIcon },
      exact: true,
      isProfileSelectedDependent: true,
      roles: [
        userRoles.sysAdmin,
        userRoles.admin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
        userRoles.operator,
        userRoles.visitor,
      ],
      component: VentureView,
    },
    {
      path: '/documentation',
      sideDrawer: { display: 'Documentação', order: 1, icon: DocsIcon },
      roles: [
        userRoles.sysAdmin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
        userRoles.operator,
        userRoles.third,
        userRoles.visitor,
      ],
      isProfileSelectedDependent: true,
      component: DocumentationRouter,
    },
    // {
    //   path: '/stores',
    //   sideDrawer: { display: 'Lojas', order: 2, icon: StoresIcon },
    //   roles: [userRoles.sysAdmin, userRoles.admin, userRoles.auditor, userRoles.holding, userRoles.operator, userRoles.venturer],
    //   isProfileSelectedDependent: true,
    //   component: StoreListPage
    // },
    {
      path: '/settings',
      sideDrawer: { display: 'Configurações', order: 3, icon: SettingsIcon },
      isProfileSelectedDependent: true,
      roles: [
        userRoles.admin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
        userRoles.operator,
      ],
      component: SettingsRouter,
    },
    {
      path: '/reports',
      sideDrawer: { display: 'Relatórios', order: 4, icon: ReportsIcon },
      roles: [
        userRoles.sysAdmin,
        userRoles.admin,
        userRoles.auditor,
        userRoles.holding,
        userRoles.venturer,
      ],
      isProfileSelectedDependent: true,
      component: ReportsRouter,
    },
    {
      path: '/help',
      sideDrawer: { display: 'Ajuda', order: 5, icon: HelpIcon },
      isProfileSelectedDependent: true,
      roles: Object.keys(userRoles),
      component: HelpRouter,
    },
    {
      path: '/',
      roles: [],
      component: Home,
    },
  ];

  render() {
    return this.props.children;
  }
}
